import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-xs tracking-[0.22em]">
        <span className="pulse-dot inline-block w-2 h-2 bg-primary rounded-full mr-3" /> SECURING SESSION…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
